<div class="fixed inset-0 z-100 flex items-center justify-center bg-black/50">
  <div class="p-12 flex items-center justify-center bg-white rounded-md">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
